import { useLanguage } from '../../shell/language-context';
import type { ViewContext } from '../offers/offer-view';
import { useOfferFormat } from '../offers/use-offer-format';
import type { HomeFormat } from './use-home-format';

// The context the offer views are built with on the home rail: the page language, the
// offer formatter (every figure goes through the i18n formatters) and the registry's
// category names (the home format supplies them).
export function useRailViews(fmt: HomeFormat): ViewContext {
  const { t, lang } = useLanguage();
  const offerFmt = useOfferFormat();
  return { lang, fmt: offerFmt, t, catLabel: fmt.catLabel };
}
